import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

const Container = styled.div`
  color: ${props => (props.highlight ? props.theme.bodyColor : props.theme.secondaryColor)};
  text-transform: uppercase;
  font: ${props => props.theme.fontWeightHeavy} 14px/16px ${props => props.theme.fontFamilyBody};

  & > span {
    cursor: pointer;
  }

  & > span.icon-lw {
    font-size: 11px;
    padding-left: 2px;
  }
`;

export default function HeaderCell({
  name, onSort, order,
}) {
  const onClick = e => {
    e && e.preventDefault();
    const direction = order === 'desc' ? 'asc' : 'desc';
    onSort(direction);
  };

  const iconClass = {
    'icon-lw-arrow-down': order === 'desc',
    'icon-lw-arrow-up': order === 'asc',
  };

  return (
    <Container onClick={onClick} highlight={!!order}>
      <span>{name}</span>
      {!!order && <span className={classNames('icon-lw', iconClass)} />}
    </Container>
  );
}

HeaderCell.propTypes = {
  name: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf([false, 'asc', 'desc']).isRequired,
};
